module.exports = __webpack_public_path__ + "static/media/cambioLlamada.5466475c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/CallWindow/cambioLlamada.svg
// module id = 1749
// module chunks = 0